module.exports = __webpack_public_path__ + "img/INTP.3906ac5f.png";